import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TablePagination } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const generateDateRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#425b8a",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
}));

const groupDaysByMonth = (dates) => {
    const months = {};
    dates.forEach(date => {
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        if (!months[monthKey]) {
            months[monthKey] = [];
        }
        months[monthKey].push(date.getDate());
    });
    return months;
};

const DateRangeTableMission = ({ startDate, endDate, datatable }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const dates = generateDateRange(startDate, endDate);
    const monthsGrouped = groupDaysByMonth(dates);

    const monthKeys = Object.keys(monthsGrouped).sort((a, b) => {
        const [yearA, monthA] = a.split('-').map(Number);
        const [yearB, monthB] = b.split('-').map(Number);
        return yearA === yearB ? monthA - monthB : yearA - yearB;
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div id="table-to-pdf">
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                             <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: 0,
                                zIndex: 3
                                }}>
                                 Référence de la mission
                            </TableCell>
                             <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '5%',
                                zIndex: 3
                                }}>
                                Direction
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '10%',
                                zIndex: 3
                                }}>
                                Service
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '15%', 
                                zIndex: 3
                                }}>
                                Matricule
                                </TableCell>
                                <TableCell style={{ 
                                width: '20%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '15%',
                                zIndex: 3
                                }}>
                                Nom et prénom(s)
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '25%',
                                zIndex: 3
                                }}>
                                Fonction
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                position: 'sticky',
                                left: '25%',
                                zIndex: 3
                                }}>
                                Objet de la mission
                                </TableCell>
                                 <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Direction de destination
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Région de destination
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                District de destination
                                </TableCell>
                                  <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Commune de destination
                                </TableCell>
                                  <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Date de départ
                                </TableCell>
                                  <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Date de retour
                                </TableCell>
                                <TableCell style={{ 
                                width: '10%', 
                                border: '1px solid #ddd', 
                                backgroundColor: '#D3D3D3',
                                zIndex: 3
                                }}>
                                Statut
                                </TableCell>
                             {monthKeys.map((monthKey) => {
                                    const [year, month] = monthKey.split('-').map(Number);
                                    const monthName = new Date(year, month - 1).toLocaleString('default', { month: 'long' });
                                    
                                    return monthsGrouped[monthKey].map((day) => (
                                        <TableCell 
                                            style={{ border: '1px solid #ddd', backgroundColor: '#D3D3D3' }} 
                                            key={`${monthKey}-${day}`}
                                        >
                                            {day} {monthName.toLowerCase()}
                                        </TableCell>
                                    ));
                                })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {datatable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((ts, index) => {
                            const isHighlighted = ts.details.length > 0;
                                    
                            return isHighlighted ? (
                                <TableRow key={`row-${index}`}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: 0,
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.reference}
                                </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: "5%",
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.direction_code}
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: '10%',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.service_code}
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: '15%',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.registration_number}
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: '20%',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.nom}
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: '25%',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.function_code}
                                </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    left: '25%',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                >
                                    {ts.mission_title}
                                </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.direction_dest}
                                </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.region}
                                </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.district}
                                </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.commune}
                                </TableCell>
                             
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.date_debut}
                                </TableCell>
                                 <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.date_fin}
                                </TableCell>
                                <TableCell
                                    component="th"
                                    scope="row"
                                    style={{
                                    position: 'sticky',
                                    backgroundColor: 'white',
                                    zIndex: 1,
                                    width: '10%'
                                    }}
                                  >
                                    {ts.final_state}
                                </TableCell>
                               {monthKeys.map((monthKey) =>
                                    monthsGrouped[monthKey].map((day, dayIndex) => {
                                        const currentMonth = parseInt(monthKey.split('-')[1], 10);
                                        
                                        const matchingDetail = ts.details.find(list => {
                                            const jourDebut = parseInt(list.jour_par_jour, 10);
                                            const moisDebut = parseInt(list.month_par_jour, 10);
                                            return currentMonth === moisDebut && day === jourDebut;
                                        });

                                        const isDayHighlighted = !!matchingDetail;

                                        const colors = matchingDetail 
                                            ? (matchingDetail.final_state === 'En attente de validation'
                                                ? '#cecece'
                                                : matchingDetail.final_state === 'Planifié'
                                                ? '#78b785'
                                                : matchingDetail.final_state === 'Nouveau'
                                                ? '#87CEEB'
                                                : matchingDetail.final_state === "Validé"
                                                ? '#78b785'
                                                : 'red')
                                            : 'transparent';
                                        return (
                                            <TableCell
                                                key={`${ts.id}-${monthKey}-${day}`}
                                                style={{
                                                    backgroundColor: colors,
                                                    color: isDayHighlighted ? 'white' : 'black',
                                                    textAlign: 'center',
                                                    border: '1px solid #ddd',
                                                }}
                                            >
                                                {isDayHighlighted ? matchingDetail.lieufinal : ''}
                                            </TableCell>
                                        );
                                    })
                                )}
                              </TableRow>
                            ) : null;
                        })}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={datatable.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    );
};

export default DateRangeTableMission;

